import { render, staticRenderFns } from "./Recuperacion.vue?vue&type=template&id=044291b4&scoped=true"
import script from "./Recuperacion.vue?vue&type=script&lang=ts"
export * from "./Recuperacion.vue?vue&type=script&lang=ts"
import style0 from "./Recuperacion.vue?vue&type=style&index=0&id=044291b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044291b4",
  null
  
)

export default component.exports